import React, { Component } from 'react';
import TextField from '@material-ui/core/TextField';
import Autocomplete from '@material-ui/lab/Autocomplete';
import withStyles from '@material-ui/core/styles/withStyles';

const useStyles = (theme) => ({
  option: {
    fontSize: 15,
    '& > span': {
      marginRight: 10,
      fontSize: 18,
    },
  },
});


class languages extends Component {
  
  handleLanguageChange = (value) => {
    this.props.onChange(value);
  }  
  
  render() {
    return (
      
      <Autocomplete
        multiple
        id="tags-outlined"
        options={languagesArray}
        defaultValue={this.props.items}
        getOptionLabel={(option) => option.label}
        onChange={(event, newValue) => {this.handleLanguageChange(newValue)}}
        filterSelectedOptions
        renderInput={(params) => (
          <TextField
            {...params}
            variant="outlined"
            label="Languages"
            placeholder="Select"
          />
        )}
      />
    );
  }
}

export default withStyles(useStyles)(languages);

export let languagesArray = [
    { code: 'es', label: 'Spanish' },
    { code: 'pt', label: 'Portuguese' },
    { code: 'en', label: 'English' },
];